const stringContainsSubOrSupTag = string =>
  string.indexOf('<sup>') > -1 || string.indexOf('<sub>') > -1

export default stringContainsSubOrSupTag



// WEBPACK FOOTER //
// ./src/utils/stringContainsSubOrSupTag.js